import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Card from '../../components/Card';
import TEXT from '../../components/Text';
import UserTransactionsList from '../../components/UserTransactionsList';
import { resetAdminUserState, getAdminUserById } from '../../../redux/actions/adminPanel/adminUsers';
import { scrollContainerIntoView } from '../../helpers/scrollIntoView';
import backCpayIcon from '../../../img/cpay-svg/arrow-back.svg';
import backNFGIcon from '../../../img/nfgpay-svg/arrow-back-nfg.svg';
import backFinvaroIcon from '../../../img/finvaro/arrow-back-finvaro.svg';
import backClarniumIcon from '../../../img/clarnium/arrow-back-clarnium.svg';
import backInexIcon from '../../../img/inex/arrow-back-inex.svg';
import backInstaIcon from '../../../img/instaXchange/arrow-back-insta.svg';
import backCoineraIcon from '../../../img/coinera/arrow-back-coinera.svg';
import { identity } from '../../../utils/getIdentity';
import Button from "../../../components/Button";
import { downloadAdminUserTransactionsInfo } from "../../../redux/actions/transactions";
import { notification } from "antd";
import { useTranslation } from "react-i18next";

const backIcon = {
  cpay: backCpayIcon,
  nfg: backNFGIcon,
  finvaro: backFinvaroIcon,
  clarnium: backClarniumIcon,
  inex: backInexIcon,
  insta: backInstaIcon,
  coinera: backCoineraIcon
};

const TransactionsByUser = ({
  getAdminUserById,
  resetAdminUserState,
  currentUserData,
  typeNetwork,
  downloadAdminUserTransactionsInfo,
  permissions
}) => {
  const { userId } = useParams();
  const { phone, email, name, surname, metamask, id } = currentUserData || {};
  const adminUserTransactionRef = useRef();
  const [dateRange, setDateRange] = useState([]);
  const { t } = useTranslation();
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  useEffect(() => () => resetAdminUserState(), []);

  const changeDate = (value) => {
    setDateRange(value);
  };

  const downloadUserTransactions = () => {
    if (!dateRange?.length) {
      notification.error({
        message: t('admin.select_date')
      });
    } else {
      downloadAdminUserTransactionsInfo(userId, {
        dateRange: dateRange,
      }, typeNetwork, selectedCurrency ? [selectedCurrency] : undefined);
    }
  }

  useEffect(() => {
    if (userId) {
      getAdminUserById(userId);
    }
  }, [userId]);

  useEffect(() => {
    scrollContainerIntoView(adminUserTransactionRef);
  }, []);

  return (
    <div className="admin-user-transactions" ref={adminUserTransactionRef}>
      <Card>
        <Link
          className={`admin-user-transactions__arrow-back admin-user-transactions__arrow-back-${identity}`}
          to="/admin/users"
        >
          <img src={backIcon[identity]} alt="arrow back" /> <span>{t('admin.go_back')}</span>
        </Link>
        <div className="admin-user-transactions--export">
          <TEXT.pageTitle>{t('admin.transactions_by_user')}</TEXT.pageTitle>
          <Button
            className={`admin-button admin-button__primary admin-button__primary-${identity}`}
            type="primary"
            onClick={downloadUserTransactions}
            disabled={permissions && permissions?.length > 0 && !permissions[1]?.edit}
          >
            {t('admin.export')}
          </Button>
        </div>
        <UserTransactionsList
          userSearchParams={email || phone || metamask?.address || id}
          userName={name && surname ? `${name} ${surname}` : name}
          userId={id}
          isFromTransactionsByUser
          changeDate={changeDate}
          setSelectedCurrency={setSelectedCurrency}
        />
      </Card>
    </div>
  );
};

const mapStateToProps = state => ({
  currentUserData: state.adminUsers.editableUser.data,
  typeNetwork: state.networkFilter,
  permissions: state.adminSettings.permissions,
});

const mapDispatchToProps = {
  getAdminUserById,
  resetAdminUserState,
  downloadAdminUserTransactionsInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsByUser);
